const aliceBlue = '#f7f9fa'
const alto = '#d0d4d9'
const apricot = '#ffc667'
const black = '#2e2e2e'
const clearBlue = '#1890ff'
const darkCream = '#ffe58f'
const emerald = '#47c79a'
const grey = '#7e7e7e'
const greyishBrown = '#4d4d4d'
const lightGrey = '#fcfcfc'
const offWhite = '#fffbe6'
const paleGrey = '#e6eaed'
const paleSkyBlue = '#bae7ff'
const pinkishGrey = '#aaaeb3'
const salmon = '#ff7878'
const salmonLight = '#fff1f0'
const salmonCream = '#ffd8d8'
const salmonMedium = '#ffd3d1'
const silver = '#bfbfbf'
const solitude = '#e8ebed'
const veryLightBlue = '#e6f7ff'
const warmGrey = '#5c6166'
const white = '#ffffff'
const whiteFour = '#d0d4d9'
const whiteTree = '#f2f5f7'

const nvPriRed = '#e50239'
const nvDarkRed = '#c2002f'
const secondary = '#1890ff'
const secondaryMedium = '#bae7ff'
const secondaryLight = '#e6f7ff'
const warning = '#ffe58f'
const warningLight = '#fffbe6'
const menu = '#333333'

export default {
  aliceBlue,
  alto,
  apricot,
  black,
  clearBlue,
  darkCream,
  emerald,
  grey,
  greyishBrown,
  lightGrey,
  menu,
  nvPriRed,
  nvDarkRed,
  offWhite,
  paleGrey,
  paleSkyBlue,
  pinkishGrey,
  salmon,
  salmonCream,
  salmonLight,
  salmonMedium,
  secondary,
  secondaryLight,
  secondaryMedium,
  silver,
  solitude,
  veryLightBlue,
  warmGrey,
  warning,
  warningLight,
  white,
  whiteFour,
  whiteTree
}
